import React, {memo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import ChangePasswordForm from './ChangePasswordForm';
import Dialog from 'components/dialogs/Dialog';
import {api} from 'api';
import {usePostApi} from 'hooks/usePostApi';
import {IChangePasswordData} from 'types/PasswordData';
import {useAuthContext} from 'context/AuthContext';
import {Msg} from 'components/notifications/NotificationContext';

interface Props {
   onClose: () => void;
   data?: {
      username?: string;
      title?: string;
      fromStartup?: boolean;
   };
}
const ChangePasswordDialog = memo(({onClose, data}: Props) => {
   const {t} = useTranslation();
   const {username, title = t('Change Password') as string, fromStartup} = data || {};

   const {
      authData: {sftpPasswordPolicies},
   } = useAuthContext();

   const onSuccess = useCallback(() => {
      Msg.notify('Password has changed successfully.');
      onClose();
   }, [onClose]);

   const {state, request, loading, error: dataError} = usePostApi(api.changepassword, {
      onSuccess,
   });

   const change = React.useCallback(
      (data: IChangePasswordData) => {
         console.debug('change password data', data);
         request(
            JSON.stringify({
               ...data,
               username,
            })
         );
      },
      [request]
   );
   return (
      <Dialog maxWidth="md" header={title} close={onClose}>
         {/* <AsyncContainer loading={loading && !dataError}> */}

         <ChangePasswordForm
            onSubmit={change}
            onClose={onClose}
            passwordData={sftpPasswordPolicies}
            // lastPasswordUpdate={lastPasswordUpdate}
         />

         {/* </AsyncContainer> */}
         {/* <ChangePasswordForm username={username} onClose={onClose} /> */}
      </Dialog>
   );
});

export default ChangePasswordDialog;
